module.exports = "/src/views/player/help/images/gazon.jpg";